import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react"
import table from "./styling/table"
import button from "./styling/button"
import popover from "./styling/popover"
import select from "./styling/select"
import menu from "./styling/menu"
import breadcrumb from "./styling/breadcrumb"
import segment from "./styling/segment"
import link from "./styling/link"
import editable from "./styling/editable"
import switchRecipe from "./styling/switch"
import accordionRecipe from "./styling/accordion"
import tabRecipe from "./styling/tab"
import card from "./styling/card"

export const config = defineConfig({
  globalCss: {
    ":where(:host > html#section-body, :root:has(div#section-body))": {
      fontSize: "15px",
    },
    "button, [role='button']": {
      fontSize: "16px",
    },
    "input, textarea, select": {
      bg: "white !important",
    },
  },
  theme: {
    breakpoints: {
      sm: "680px",
      md: "968px",
      lg: "1224px",
      xl: "1480px",
      "2xl": "1736px",
      "3xl": "2120px",
      "4xl": "2760px",
    },
    tokens: {
      colors: {
        primary: { value: "#2B2B2B" },
        primary_light: { value: "#545454" },
        highlight: { value: "#0bc5ea" },
        active: { value: "#a170d9" },
        error: { value: "#d2042d" },
        error_light: { value: "#ea0b3b" },
        blue: { value: "#39aed2" },
        grey: { value: "#a9a9a9" },
        grey_light: { value: "rgba(102, 102, 102, 0.4)" },
        grey_dark: { value: "rgba(102, 102, 102, 0.8)" },
        blue_dark: { value: "#19596d" },
        blue_light: { value: "#90d2e6" },
        red: { value: "#d2042d" },
        background: { value: "#F2F0EF" },
        sidebar: { value: "#2D2860" },
        card: { value: "white" },

        solar: { value: "#10B981" },
        fuel: { value: "#8B5CF6" },
        genset: { value: "#64748B" },
        battery: { value: "#F59E0B" },
        distro: { value: "#2563EB" },
      },
      fonts: {
        heading: { value: "montserrat" },
        body: { value: "montserrat" },
        mono: { value: "montserrat" },
        global: { value: "montserrat" },
      },
      shadows: {
        card: { value: "0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.04)" },
      },
      radii: {
        card: { value: "5px" },
      },
      zIndex: {
        toast: { value: 1700 },
        dialog: { value: 1800 },
      },
    },
    recipes: {
      button,
      link,
    },
    slotRecipes: {
      table,
      popover,
      select,
      menu,
      breadcrumb,
      segment,
      editable,
      switch: switchRecipe,
      accordion: accordionRecipe,
      tabs: tabRecipe,
      card,
    },
  },
  cssVarsRoot: ":where(:host > html#section-body, :root:has(div#section-body))",
  cssVarsPrefix: "planner",
  disableLayers: true,
  strictTokens: false,
})

/** Default system for Chakra typegen (expects `$$chakra` on default export). */
export default createSystem(defaultConfig, config)
